import React from 'react';
import { COLORS } from '../../styles/variables';

interface FilterIconProps {
  size?: number;
  color?: string;
}

const FilterIcon: React.FC<FilterIconProps> = ({ size = 24, color = COLORS.white }) => (
  <svg width={size} height={size} viewBox="0 0 32 31" fill="none">
    <path
      d="M 3 3 L 29 3 L 18 16 L 18 26 L 14 30 L 14 16 L 3 3"
      fill="transparent"
      stroke={color}
    />
  </svg>
);

export default FilterIcon;
